/* eslint-disable */
export default {
  order: 7,
  header: [],
  content: [
    {
      category: '2.1 Release Notes (2020/06/30)',
      description: '查看 EnOS 版本信息。',
      url: '',
      isVersionInfo: true,
      item: [
        {
          name: 'EnOS 2.1',
          description: '',
          list: [
            {
              name: '新增服务与功能',
              url: '/docs/enos/zh_CN/2.1.0/releasenotes/2.1.0_update/new_feature.html'
            },
            {
              name: '行为变更',
              url: '/docs/enos/zh_CN/2.1.0/releasenotes/2.1.0_update/enhancement.html'
            },
            {
              name: '已知问题',
              url: '/docs/enos/zh_CN/2.1.0/releasenotes/knownissue.html'
            }
          ]
        }
      ]
    },
    {
      category: 'EnOS 基础及核心服务',
      description: 'EnOS，全球领先的智能物联网操作系统，致力于推动企业和城市数字化转型，实现生态发展。',
      image: '',
      url: '/docs/enos/zh_CN/2.1.0/overview/enos_introduction.html',
      item: [
        {
          name: '入门信息',
          description: '了解EnOS的产品优势、关键概念，快速开始使用EnOS。',
          image: '',
          list: [
            {
              name: '什么是EnOS',
              url: '/docs/enos/zh_CN/2.1.0/overview/enos_introduction.html'
            },
            {
              name: 'EnOS入门指引',
              url: '/docs/enos/zh_CN/2.1.0/getting_started_with_enos/getting_started_with_enos.html'
            },
            {
              name: '常见问题',
              url: '/docs/enos/zh_CN/2.1.0/faq/index.html'
            }
          ]
        },
        {
          name: 'EnOS 管理门户',
          description: '为物联网实施人员、数据科学家和应用开发者等提供统一的基于GUI操作界面，一站式管理物联网连接、数据、分析、应用的全生命周期，带来流畅一致的体验。',
          image: '',
          list: [
            {
              name: '访问 EnOS',
              url: '/docs/enos/zh_CN/2.1.0/overview/accessing_enos.html'
            },
            {
              name: 'EnOS 管理门户 GUI 使用惯例',
              url: '/docs/enos/zh_CN/2.1.0/overview/ui_conventions.html'
            }
          ]
        },
        {
          name: '身份与授权',
          description: '提供用户帐号生命周期管理，支持对EnOS资源的访问权限控制，实现对用户身份与权限的集中化、灵活化管理，有效保护企业信息安全。',
          image: '',
          list: [
            {
              name: '有关身份与授权',
              url: '/docs/enos/zh_CN/2.1.0/iam/iam_overview.html'
            },
            {
              name: '入门指引',
              url: '/docs/enos/zh_CN/2.1.0/iam/iam_gettingstarted_adduser.html'
            },
            {
              name: 'LDAP联合',
              url: '/docs/enos/zh_CN/2.1.0/iam/ldap/index.html'
            }
          ]
        },
        {
          name: '资源管理',
          description: '支持对资源使用的灵活管理，可对资源利用进行告警设置，提高企业资源透明度与资源利用率，减少资源成本浪费。',
          image: '',
          list: [
            {
              name: 'EnOS上的资源',
              url: '/docs/enos/zh_CN/2.1.0/resourcemanagement/overview.html'
            },
            {
              name: '资源规格说明',
              url: '/docs/enos/zh_CN/2.1.0/resourcemanagement/reference/index.html'
            },
            {
              name: '快速申请资源',
              url: '/docs/enos/zh_CN/2.1.0/resourcemanagement/getstarted.html'
            }
          ]
        },
        {
          name: '审计服务',
          description: '支持对用户的登录登出和各项操作行为进行监控和审计，操作历史事件在保存期内可保证所有记录的不可篡改性和可追溯性，满足企业客户的安全合规要求。',
          image: '',
          list: [
            {
              name: '操作审计',
              url: '/docs/enos/zh_CN/2.1.0/audit/audit_overview.html'
            }
          ]
        },
        {
          name: '应用注册',
          description: '支持应用开发者快速进行应用的注册、购买、编辑、导出等，实现便捷的应用管理。',
          image: '',
          list: [
            {
              name: '注册和管理应用',
              url: '/docs/app-development/zh_CN/2.1.0/app_management/managing_apps.html'
            }
          ]
        },
        {
          name: 'EnOS API',
          description: '提供涵盖 EnOS 各个核心业务流程的 API 接口和 API 文档，帮助快速访问系统资源，加速应用开发。',
          image: '',
          list: [
            {
              name: '有关 EnOS API',
              url: '/docs/api/zh_CN/2.1.0/overview.html'
            },
            {
              name: 'API 鉴权',
              url: '/docs/api/zh_CN/2.1.0/authen_overview.html'
            },
            {
              name: 'EnOS API 快速入门',
              url: '/docs/api/zh_CN/2.1.0/gettingstarted.html'
            },
            {
              name: 'API 参考文档',
              url: '/docs/api/zh_CN/2.1.0/api_reference.html'
            }
          ]
        },
        {
          name: '安全',
          description: '了解EnOS中内置的安全技术。',
          image: '',
          list: [
            {
              name: '安全概览',
              url: '/docs/enos/zh_CN/2.1.0/security/security_overview.html'
            },
            {
              name: 'X.509 证书服务',
              url: '/docs/enos/zh_CN/2.1.0/security/x509_ca/index.html'
            },
            {
              name: '身份与权限管理',
              url: '/docs/enos/zh_CN/2.1.0/iam/iam_overview.html'
            }
          ]
        },
        {
          name: '数据源注册',
          description: '支持 EnOS 内外部数据源统一注册及管理，以供相关产品模块直接访问数据源信息。',
          image: '',
          list: [
            {
              name: '数据源注册概述',
              url: '/docs/data-source-reg/zh_CN/2.1.0/datasource_overview.html'
            },
            {
              name: '注册各类数据源',
              url: '/docs/data-source-reg/zh_CN/2.1.0/index.html'
            }
          ]
        }
      ]
    },

    {
      category: 'EnOS Edge',
      description: 'EnOS Edge 通过内置协议库适配并加速设备连接，提供边缘计算和本地控制，帮助用户及时决策和响应，将云端智能扩展至边缘。EnOS Edge 基于软件且支持各类硬件，提供灵活、经济和高效的解决方案，满足不同业务场景的需求。',
      image: 'assets/images/EnOS Edge_LIght.png',
      url: '/docs/enos-edge/zh_CN/2.1.0/edge_overview.html',
      item: [
        {
          name: '',
          description: '',
          image: '',
          list: [
            {
              name: '产品简介',
              url: '/docs/enos-edge/zh_CN/2.1.0/edge_overview.html'
            },
            {
              name: '用户指南',
              url: '/docs/enos-edge/zh_CN/2.1.0/howto/console_configuration/connecting_edge.html'
            },
            {
              name: '开发指南',
              url: '/docs/enos-edge/zh_CN/2.1.0/howto/developer_guide/app_dev_overview.html'
            },
            {
              name: 'EnOS Edge API',
              url: '/docs/edge-api/zh_CN/2.1.0/index.html'
            },
            {
              name: '参考',
              url: '/docs/enos-edge/zh_CN/2.1.0/reference/protocol_list.html'
            }
          ]
        }
      ]
    },

    {
      category: 'IoT Hub',
      description: '广泛、安全和快速的连接到多源异构的传感器、设备及系统，提供设备的全生命周期管理。',
      image: 'assets/images/IoT Hub_LIght.png',
      url: '/docs/dcm/zh_CN/2.1.0/iot_hub_overview.html',
      item: [
        {
          name: '设备连接与管理服务',
          description: '支持海量异构设备或系统的实时和历史数据的快速接入和管理；内置数字孪生模型库，快速实现行业领域设备的数字化抽象；提供设备的全生命周期管理和动态告警触发，实现设备异常及故障的快速响应。',
          image: 'assets/images/iothub/Connectivity.png',
          list: [
            {
              name: '设备连接概述',
              url: '/docs/device-connection/zh_CN/2.1.0/device_management_overview.html'
            },
            {
              name: '模型管理',
              url: '/docs/device-connection/zh_CN/2.1.0/howto/model/index.html'
            },
            {
              name: '告警管理',
              url: '/docs/alert/zh_CN/2.1.0/learn/alert_overview.html'
            },
            {
              name: '设备连接快速入门',
              url: '/docs/device-connection/zh_CN/2.1.0/tutorial/connecting_device_simulated/index.html'
            },
            {
              name: 'API 文档',
              url: '/docs/device-connection/zh_CN/2.1.0/reference/api_reference'
            }
          ]
        }
      ]
    },

    {
      category: '企业数据平台',
      image: 'assets/images/Enterprise Data Platform_LIght.png',
      description: '挖掘数据资产价值，降低海量物联网数据的TCO，帮助你实现对设备资产数据的高效管理。',
      url: '/docs/data-asset/zh_CN/2.1.0/data_asset_overview.html',
      item: [
        {
          name: '数据资产目录（预览）',
          description: '助力海量多源数据的统一元数据分类管理、高效检索、血缘追踪等全面的数据治理活动，帮助快速理解企业数据资产，实现数据资产的集中式管理及分析。',
          image: 'assets/images/edp/Data_Asset_Catalog.png',
          list: [
            {
              name: '数据资产目录概述',
              url: '/docs/data-asset-catalog/zh_CN/2.1.0/metadata_explorer.html'
            },
            {
              name: '入门指引',
              url: '/docs/data-asset-catalog/zh_CN/2.1.0/exploring_metadata.html'
            }
          ]
        },
        {
          name: '流数据处理',
          description: '沉淀典型计算场景的通用算子及模板，支持数据开发者拖拽式无代码快速开发流数据处理与分析的任务流。',
          image: 'assets/images/edp/Stream_Processing.png',
          list: [
            {
              name: '流数据处理概述',
              url: '/docs/stream-processing/zh_CN/2.1.0/streaming_overview.html'
            },
            {
              name: '开发流数据处理任务',
              url: '/docs/stream-processing/zh_CN/2.1.0/dev.html'
            },
            {
              name: '运维流数据处理任务',
              url: '/docs/stream-processing/zh_CN/2.1.0/ops.html'
            },
            {
              name: 'API 文档',
              url: '/docs/stream-processing-api/zh_CN/2.1.0/overview.html'
            }
          ]
        },
        {
          name: '时序数据管理',
          description: '为海量物联网时序数据提供高吞吐、高可用、高压缩比的存储，并配套提供高效查询API及可视化工具，实现对时序数据的快速洞察。',
          image: 'assets/images/edp/Time_Series_Data_Management.png',
          list: [
            {
              name: '存储策略',
              url: '/docs/time-series-data/zh_CN/2.1.0/policy.html'
            },
            {
              name: '时序洞察',
              url: '/docs/time-series-data/zh_CN/2.1.0/insights.html'
            },
            {
              name: '数据清理',
              url: '/docs/time-series-data/zh_CN/2.1.0/cleanup.html'
            },
            {
              name: 'API 文档',
              url: '/docs/tsdb-data-api/zh_CN/2.1.0/overview.html'
            }
          ]
        },
        {
          name: '数据联邦',
          description: '在不移动或同步数据的情况下，为企业的多源异构数据存储系统建立统一的数据读写服务，赋能不同的数据使用方能够通过标准 SQL、JDBC、或 OData 等统一查询方式高效访问数据。',
          image: 'assets/images/edp/Data_Federation.png',
          list: [
            {
              name: '数据联邦概述',
              url: '/docs/data-federation/zh_CN/2.1.0/data_federation_overview.html'
            },
            {
              name: '管理数据联邦通道',
              url: '/docs/data-federation/zh_CN/2.1.0/managing_channel.html'
            },
            {
              name: '读写数据',
              url: '/docs/data-federation/zh_CN/2.1.0/reading_writing_data.html'
            },
            {
              name: 'API 文档',
              url: '/docs/data-federation-api/zh_CN/2.1.0/overview.html'
            }
          ]
        },
        {
          name: '数据订阅',
          description: '数据订阅服务支持将订阅的数据实时推送给消费数据的应用，提高应用获取和消费资产数据的效率。基于数据订阅服务提供的 SDK，应用可高效地进行数据订阅。',
          image: 'assets/images/edp/Data_Subscription.png',
          list: [
            {
              name: '数据订阅概述​',
              url: '/docs/data-subscription/zh_CN/2.1.0/data_subscription_overview.html'
            },
            {
              name: '数据订阅快速入门',
              url: '/docs/data-subscription/zh_CN/2.1.0/gettingstarted_subscribe_realtime.html'
            },
            {
              name: '消费订阅数据',
              url: '/docs/data-subscription/zh_CN/2.1.0/consuming_subscribed_data.html'
            },
            {
              name: '数据订阅 SDK 参考',
              url: '/docs/data-subscription/zh_CN/2.1.0/data_subscription_sdk.html'
            }
          ]
        },
        {
          name: '数据归档',
          description: '通过周期性归档任务实现大规模数据备份，对访问频率较低且占用存储空间大的“冷数据”进行经济化存储。',
          image: 'assets/images/edp/Data_Archiving.png',
          list: [
            {
              name: '数据归档概述',
              url: '/docs/data-archiving/zh_CN/2.1.0/archive_policy.html'
            },
            {
              name: '配置数据归档任务',
              url: '/docs/data-archiving/zh_CN/2.1.0/configuring_archive_storage.html'
            },
            {
              name: '数据归档逻辑说明',
              url: '/docs/data-archiving/zh_CN/2.1.0/archive_storage.html'
            }
          ]
        },
        {
          name: '数据同步（预览）',
          description: '打通外部存储系统与 EnOS 内部存储系统之间的数据传输通道，帮助实现集中式数据同步和共享。',
          image: 'assets/images/edp/Data_Synchronization.png',
          list: [
            {
              name: '数据同步概述',
              url: '/docs/data-sync/zh_CN/2.1.0/di_overview.html'
            },
            {
              name: '从外部数据库同步数据到EnOS Hive',
              url: '/docs/data-sync/zh_CN/2.1.0/creating_scratch_onetime.html'
            },
            {
              name: '从EnOS Hive同步数据到目的数据库',
              url: '/docs/data-sync/zh_CN/2.1.0/creating_scratch_hive2mysql.html'
            }
          ]
        },
        {
          name: '批数据处理',
          description: '帮助数据开发者通过可视化任务流的方式进行大规模数据处理，提供稳定的调度服务，并可基于数据湖、数据仓库及用户侧应用，对相关数据进行计算、分析、洞察等。',
          image: 'assets/images/edp/Batch_Processing.png',
          list: [
            {
              name: '批数据处理概述​',
              url: '/docs/batch-processing/zh_CN/2.1.0/dataide_overview.html'
            },
            {
              name: '任务资源管理',
              url: '/docs/batch-processing/zh_CN/2.1.0/job_resource/index.html'
            },
            {
              name: '任务流开发',
              url: '/docs/batch-processing/zh_CN/2.1.0/data_dev/index.html'
            },
            {
              name: '任务流运维',
              url: '/docs/batch-processing/zh_CN/2.1.0/task_monitor/index.html'
            }
          ]
        },
        {
          name: '数据资产权限（预览）',
          description: '对组织数据资产访问权限进行集中式管理，提升数据平台系统安全性。',
          image: '',
          list: [
            {
              name: '数据资产权限概述​',
              url: '/docs/data-asset-auth/zh_CN/2.1.0/data_asset_permission.html'
            },
            {
              name: '管理数据资产权限策略',
              url: '/docs/data-asset-auth/zh_CN/2.1.0/managing_permission_policy.html'
            }
          ]
        }
      ]
    },

    {
      category: '应用使能平台',
      image: 'assets/images/Application_Enablement_Platform_LIght.png',
      description: '提供应用开发所需的工具组件、函数库、和服务，帮助你快速构建、部署、和扩展应用。',
      url: '/docs/app-development/zh_CN/2.1.0/app_dev_overview.html',
      item: [
        {
          name: '应用开发基础',
          description: '基于 EnOS 提供的应用开发服务和组件，快速开始应用设计、开发、部署、和托管。',
          image: 'assets/images/aep/Application_Development_Basics.png',
          list: [
            {
              name: '注册和管理应用',
              url: '/docs/app-development/zh_CN/2.1.0/app_management/managing_apps.html'
            },
            {
              name: '使用 EnOS SDK 开发应用',
              url: '/docs/app-development/zh_CN/2.1.0/sdk_overview.html'
            },
            {
              name: '开发和发布 API',
              url: '/docs/apim/zh_CN/2.1.0/api_management_overview.html'
            }
          ]
        },
        {
          name: 'Application Portal',
          description: '与 EnOS 的服务及数据天然集成，通过应用程序用户身份和访问权限的集中管理及一致的网页和移动端响应式应用框架，帮助降低应用开发成本，实现跨应用的一体化体验。',
          image: 'assets/images/aep/Application_Portal.png',
          list: [
            {
              name: '有关 Application Portal',
              url: '/docs/app-portal/zh_CN/2.1.0/overview.html'
            },
            {
              name: '关键概念',
              url: '/docs/app-portal/zh_CN/2.1.0/concept.html'
            },
            {
              name: '使用管理后台',
              url: '/docs/app-portal/zh_CN/2.1.0/ou_admin/index.html'
            },
            {
              name: 'Application Portal API',
              url: '/docs/app-portal-api/zh_CN/2.1.0/overview.html'
            }
          ]
        },
        {
          name: '数据可视化',
          description: '内置丰富的图形组件，以简洁和无代码低代码的开发体验帮助开发者快速构建可视化应用，结合2D和3D技术，增强监控和运营应用的用户体验。',
          image: 'assets/images/aep/Digital_Twin_Visualization.png',
          list: [
            {
              name: '有关 Digital Twin Visualization',
              url: '/docs/dtv/zh_CN/2.1.0/overview.html'
            },
            {
              name: '构建监控页面',
              url: '/docs/dtv/zh_CN/2.1.0/dtde/index.html'
            }
          ]
        },
        {
          name: '通知管理（预览）',
          description: '为 EnOS 服务和基于 EnOS 开发的应用提供短信、邮件等推送服务，进行统一推送管理，保障推送高触达及安全性，并提供配额及计量管理，优化资源分配。',
          image: 'assets/images/aep/Notification_Management.png',
          list: [
            {
              name: '通知管理概述',
              url: '/docs/enos/zh_CN/2.1.0/notification_center/notification_center_overview.html'
            }
          ]
        },
        {
          name: 'API 管理',
          description: '提供安全的 API 全生命周期管理，帮助企业快速通过 API 实现业务增长和开放集成。',
          image: 'assets/images/aep/API_Management.png',
          list: [
            {
              name: 'API 管理概述',
              url: '/docs/apim/zh_CN/2.1.0/api_management_overview.html'
            },
            {
              name: 'API 生命周期管理',
              url: '/docs/apim/zh_CN/2.1.0/api_lifecycle_management.html'
            },
            {
              name: 'API 管理安全机制',
              url: '/docs/apim/zh_CN/2.1.0/apim_security.html'
            },
            {
              name: '入门指引',
              url: '/docs/apim/zh_CN/2.1.0/learn/api_management_quickstart.html'
            }
          ]
        },
        {
          name: '应用托管',
          description: '基于 Helm Chart 陈列通用和可复用组件或服务的集合，对该类服务以模板形式进行快速部署，简化业务应用的开发。',
          image: 'assets/images/aep/Application_Hosting.png',
          list: [
            {
              name: '管理应用模板',
              url: '/docs/ecp/zh_CN/2.1.0/howto/app_hub/managing_app_template.html'
            },
            {
              name: '部署应用实例',
              url: '/docs/ecp/zh_CN/2.1.0/howto/app_hub/deploying_app_instance.html'
            }
          ]
        },
        {
          name: '函数服务',
          description: '提供事件驱动的函数计算服务，以弹性、可靠的方式运行函数代码，实现函数级资源分配和调度。',
          image: 'assets/images/aep/Serverless.png',
          list: [
            {
              name: '发布函数类型应用',
              url: '/docs/ecp/zh_CN/2.1.0/howto/serverless/managing_function.html'
            }
          ]
        },
        {
          name: '单点登录服务',
          description: '基于主流的标准协议，实现 EnOS 平台与第三方应用的单点登录，解决同一公司跨业务应用间的身份认证问题。',
          image: 'assets/images/aep/Single_Sign-On_Service.png',
          list: [
            {
              name: '概述',
              url: '/docs/enos/zh_CN/2.1.0/iam/sso/sso_overview.html'
            }
          ]
        },
        {
          name: '容器集群管理',
          description: '基于原生 Kubernetes，通过高可用、易操作的容器集群资源管理、部署和运维服务，提升容器集群管理便捷性，降低运维成本。',
          image: 'assets/images/aep/Container_Cluster_Management.png',
          list: [
            {
              name: '容器集群管理概述',
              url: '/docs/ecp/zh_CN/2.1.0/howto/container/index.html'
            }
          ]
        },
        {
          name: '组态工具',
          description: '提供丰富的工业领域图形组件，帮助快速构建资产数据可视化和工业监控应用。',
          image: 'assets/images/aep/EnOS_HMI.png',
          list: [
            {
              name: '有关 EnOS 组态工具',
              url: '/docs/app-development/zh_CN/2.1.0/hmi/hmi_overview.html'
            },
            {
              name: '开发部署数据监控页面',
              url: '/docs/app-development/zh_CN/2.1.0/hmi/deploying_graph.html'
            }
          ]
        }
      ]
    }
  ]
};
